import {
	Breakpoints,
	BreakpointWrapper,
	Layout,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import styled from 'styled-components';
import { CustomBreakpoints } from '../../helpers/breakpoints';
import {
	CarlineWithOfertas,
	FinanceData,
	Oferta,
	Promocion,
} from '../../services/ofertas-service/models/ofertas';
import { OfertaCardsContainer } from '../oferta-card/oferta-cards-container';
import { ModelCarrousel } from './model-carrousel';
import ModelTitleBackground from './model-title-background';

const ModelCarrouselLayout = styled.div<{ hasOneCarline: boolean }>`
	//overflow: hidden;
	position: absolute;
	right: 0;

	// Tablet size
	@media screen and (min-width: 960px) and (max-width: 1199px) {
		top: ${(props) => (props.hasOneCarline ? '0' : '14vh')};
		position: ${(props) => props.hasOneCarline && 'unset'};
		//height: ${(props) => props.hasOneCarline && '25vh'};
		align-content: ${(props) => props.hasOneCarline && 'center'};
		margin-bottom: ${(props) => props.hasOneCarline && '40px'};
	}

	@media screen and (min-width: 1200px) {
		height: 100%;
		align-content: center;
	}

	max-height: 330px;
`;

const ModelTitleBackgroundContainer = styled.div<{
	isActive: boolean;
	hasOneCarline: boolean;
}>`
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	align-content: center;

	& > div {
		display: ${(props) => !props.isActive && 'none'};
	}

	//Esto nos permite que el texto haga overflow
	& * {
		overflow: visible !important;
	}

	// Tablet size
	@media screen and (min-width: 960px) and (max-width: 1199px) {
		height: ${(props) => props.hasOneCarline && ' 25vh'};
	}
`;

const CardContainer = styled.div`
	position: relative;
	left: 0;
	width: 100vw;

	@media screen and (min-width: 1200px) {
		& > div {
			height: 100%;
			align-content: center;
		}
	}
`;

const ModelFrameContainer = styled.div`
	@media screen and (max-width: 959px) {
		overflow-x: scroll;
	}

	@media screen and (min-width: 1200px) {
		position: relative;
	}
`;

export const ModelFrame = ({
	carline,
	hasOneCarline,
	isActive,
	isLayerVisible,
	setIsLayerVisible,
	selectedOferta,
	setSelectedOferta,
	handleLayerOnClick,
	setSelectedPromotion,
	setIsFinanceLayerVisible,
	setFinanceData,
	handleScrollToDisclaimer,
	isCallMeNowOpen,
}: {
	carline: CarlineWithOfertas;
	hasOneCarline: boolean;
	isActive: boolean;
	isCallMeNowOpen: boolean;
	isLayerVisible: boolean;
	setIsLayerVisible: React.Dispatch<React.SetStateAction<boolean>>;
	selectedOferta: Oferta;
	setSelectedOferta: React.Dispatch<React.SetStateAction<Oferta>>;
	className: string;
	handleLayerOnClick: () => void;
	setSelectedPromotion: React.Dispatch<
		React.SetStateAction<Promocion | undefined>
	>;
	setIsFinanceLayerVisible: React.Dispatch<React.SetStateAction<boolean>>;
	setFinanceData: React.Dispatch<React.SetStateAction<FinanceData>>;
	handleScrollToDisclaimer: (reference: string) => void;
}): React.ReactElement => {
	return (
		<ModelFrameContainer>
			<ModelTitleBackgroundContainer
				className="model-frame__model-title-background-container"
				isActive={isActive}
				hasOneCarline={hasOneCarline}
			>
				<Layout
					data-testid="model-frame_layout-ofertas-title"
					appearance={{
						[Breakpoints.default]: [{ name: 'a', columns: 24 }],
						[Breakpoints.b960]: hasOneCarline
							? [
									{ name: '.', columns: 0 },
									{ name: 'a', columns: 24 },
									{ name: '.', columns: 0 },
								]
							: [
									{ name: '.', columns: 1 },
									{ name: 'a', columns: 13 },
									{ name: '.', columns: 10 },
								],
						[Breakpoints.b1920]: [
							{ name: '.', columns: 1 },
							{ name: 'a', columns: 14 },
							{ name: '.', columns: 9 },
						],
						[Breakpoints.b2560]: [
							{ name: '.', columns: 1 },
							{ name: 'a', columns: 15 },
							{ name: '.', columns: 2 },
						],
					}}
				>
					<ModelTitleBackground
						text={carline?.title.replace(/-/g, '\u2011')}
						hasOneCarline={hasOneCarline}
					/>
				</Layout>
			</ModelTitleBackgroundContainer>

			<ModelCarrouselLayout
				className="model-frame__model-carrousel-layout"
				hasOneCarline={hasOneCarline}
			>
				{isActive && (
					<ModelCarrousel
						mediaAssets={selectedOferta.configuracion.mediaAssets}
					/>
				)}
			</ModelCarrouselLayout>

			<BreakpointWrapper min={CustomBreakpoints.DESKTOP}>
				<CardContainer className="model-frame__card-container">
					<Layout
						data-testid="model-frame_layout-ofertas-card"
						appearance={{
							[Breakpoints.default]: [{ name: 'a', columns: 24 }],
							[Breakpoints.b960]: [
								{ name: '.', columns: 1 },
								{ name: 'a', columns: 22 },
								{ name: '.', columns: 1 },
							],
							[CustomBreakpoints.DESKTOP]: [
								{ name: '.', columns: 14 },
								{ name: 'a', columns: 9 },
								{ name: '.', columns: 1 },
							],
							[Breakpoints.b1920]: [
								{ name: '.', columns: 15 },
								{ name: 'a', columns: 8 },
								{ name: '.', columns: 1 },
							],
							[Breakpoints.b2560]: [
								{ name: '.', columns: 16 },
								{ name: 'a', columns: 6 },
								{ name: '.', columns: 1 },
							],
						}}
					>
						{isActive && (
							<OfertaCardsContainer
								className="model-frame__oferta-cards-container"
								carline={carline}
								hasOneCarline={hasOneCarline}
								isMobile={false}
								isLayerVisible={isLayerVisible}
								setIsLayerVisible={setIsLayerVisible}
								selectedOferta={selectedOferta}
								setSelectedOferta={setSelectedOferta}
								handleLayerOnClick={handleLayerOnClick}
								setSelectedPromotion={setSelectedPromotion}
								setIsFinanceLayerVisible={setIsFinanceLayerVisible}
								setFinanceData={setFinanceData}
								handleScrollToDisclaimer={handleScrollToDisclaimer}
								isCallMeNowOpen={isCallMeNowOpen}
							/>
						)}
					</Layout>
				</CardContainer>
			</BreakpointWrapper>
		</ModelFrameContainer>
	);
};
